import { render, staticRenderFns } from "./CpuLoadChart.vue?vue&type=template&id=8ace1c46&scoped=true"
import script from "./CpuLoadChart.vue?vue&type=script&lang=js"
export * from "./CpuLoadChart.vue?vue&type=script&lang=js"
import style0 from "./CpuLoadChart.vue?vue&type=style&index=0&id=8ace1c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ace1c46",
  null
  
)

export default component.exports